 
<template>
  <div class="custom-6" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      <div class="left">
        <div class="left-img">
          <img src="../../static/IM/im-33.png" alt="" />
        </div>
        <div class="left-content">
          <div class="title">我已完成报告解读</div> 
          <div class="descript">共有 <span> {{ JSON.parse(payloadData.data).abnormalResultsCount }}</span> 项异常</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payloadData: {
      type: Object,
      default: () => {}
    },
    IMInfo: {
      type: Object
      // default: () => {},
    },
    bgColor: {
      type: String,
      default: "#F5F5F5"
    },
    color: {
      type: String,
      default: "#333"
    }
  },
  data() {
    return {};
  },

  methods: {}
};
</script>

<style lang="less" scoped>
.descript span {
  color: #1a7bfc;
}
.custom-6 {
  border-radius: 4px;
  width: 350px;
  border-radius: 4px;

  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-img {
        margin-right: 15px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .left-content {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;

        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
          margin-bottom: 12px;
        }
      }
    }
    .right {
      .btn {
        width: 62px;
        height: 27px;
        border-radius: 14px;
        border: 1px solid #0cb79f;

        font-size: 12px;
        color: #0cb79f;
        line-height: 27px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>